import loadable from "@loadable/component";

export const PabbitLiteList = loadable(() => import("./pabbit-lite"), {
  resolveComponent: ({ PabbitLiteList }) => PabbitLiteList,
});

export const PabbitLiteDeviceLog = loadable(
  () => import("./pabbit-lite/DeviceLog"),
  { resolveComponent: ({ PabbitLiteDeviceLog }) => PabbitLiteDeviceLog }
);

export const PabbitLiteEntranceLog = loadable(
  () => import("./pabbit-lite/EntranceLog"),
  { resolveComponent: ({ PabbitLiteEntranceLog }) => PabbitLiteEntranceLog }
);

export const DearisList = loadable(() => import("./dearis"), {
  resolveComponent: ({ DearisList }) => DearisList,
});

export const LockerList = loadable(() => import("./locker"), {
  resolveComponent: ({ LockerList }) => LockerList,
});

export const ParcelLockerManagement = loadable(
  () => import("./locker/ParcelLockerManagement"),
  { resolveComponent: ({ ParcelLockerManagement }) => ParcelLockerManagement }
);

export const UnlockRecords = loadable(() => import("./locker/UnlockRecords"), {
  resolveComponent: ({ UnlockRecords }) => UnlockRecords,
});

export const NotifyList = loadable(() => import("./notify"), {
  resolveComponent: ({ NotifyList }) => NotifyList,
});

export const DeviceDetail = loadable(() => import("./device-detail"));

export const EventsList = loadable(() => import("./events/list"));

export const EventsDetail = loadable(() => import("./events/show"));

export const ImeiList = loadable(() => import("./imei/list"));

export const ImeiEvents = loadable(() => import("./imei/events"));
